import React from "react";
import CallDetailsCard from "./CallDetailsCard";
import MessageMetaInfo from "../MessageMetaInfo";
import { DATE_TIME_FORMATS } from "../../../../utils/dateTimes";

const FROM_LEAD = "FROM_LEAD";
const TO_LEAD = "TO_LEAD";
const AI_RESPONSE_TO_LEAD = "AI Response To Lead";

const CallMessage = ({ message, RenderPhone }) => {
  const { call } = message;

  // Determine if this is an outgoing call (TO_LEAD)
  const isOutgoingCall = message.direction === TO_LEAD;

  // Determine if this is an incoming call (FROM_LEAD)
  const isIncomingCall = message.direction === FROM_LEAD;

  // Find first truthy recording URL from callRecordings array
  const getRecordingUrl = () => {
    if (call?.callRecordings && Array.isArray(call.callRecordings)) {
      const recording = call.callRecordings.find(recording => recording?.recordingUrl);
      return recording?.recordingUrl;
    }
  };

  // Get display name based on call direction
  const getDisplayName = () => {
    if (isOutgoingCall) {
      return call?.user ? `${call?.user?.firstName} ${call?.user?.lastName}` : call?.fromName;
    }
    return call?.lead ? `${call?.lead?.firstName} ${call?.lead?.lastName}` : call?.fromName;
  };

  // Determine responsive width classes
  const responsiveWidth = "msg-bubble-wrapper";

  // Determine call container classes
  const callContainerClasses = isOutgoingCall
    ? "smaiCall rounded-tr-none ml-auto w-full"
    : "smaiCall";

  // Determine override class name for CallDetailsCard
  const overrideClassName = isOutgoingCall ? "smaiCallSent" : "smaiCallRecieve";

  const callDirection = isOutgoingCall ? TO_LEAD : FROM_LEAD;

  return (
    <div className={`${responsiveWidth} w-webkit-fill mx-1`}>
      <MessageMetaInfo
        direction={callDirection}
        messageType={message?.messageType}
        contentType={message?.contentType}
        avatarUser={{
          fullName: call?.user
            ? `${call?.user?.firstName} ${call?.user?.lastName}`
            : call?.fromName,
          profilePic: message?.user?.profilePic,
        }}
        leadName={getDisplayName()}
        displayName={getDisplayName()}
        timestamp={isOutgoingCall ? message?.dateSent : message?.dateReceived}
        timestampFormat={DATE_TIME_FORMATS.h_mm_A}
        timestampFullFormat={DATE_TIME_FORMATS.ddd_MMM_Do_YYYY_hh_mm_A}
        userName={getDisplayName()}
        RenderPhone={RenderPhone}
        phoneNumber={isOutgoingCall ? call?.toNumber || "" : call?.fromNumber || ""}
        phoneLabel="Call"
        phoneSentLabel="made to"
        phoneReceiveLabel="received from"
        showPhoneIcon
      >
        <div className={callContainerClasses}>
          <CallDetailsCard
            call={call}
            recordingUrl={getRecordingUrl()}
            callSummary={message?.content || ""}
            overrideClassName={overrideClassName}
          />
        </div>
      </MessageMetaInfo>
    </div>
  );
};

export default CallMessage;
